/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".block-keywords{width:100%;height:95%;overflow-y:auto}.block-keywords>ig-row ig-col{padding:0;margin-right:5rem}.block-keywords .block-image{max-height:50px;max-width:100px}.block-keywords .blacklist-column-width{width:34%}.block-keywords .block-column-width{width:25%}.block-keywords .long-description{position:relative;line-height:100%;max-height:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.block-keywords ig-button{margin-top:24px;width:100px}.block-domain ig-multi-fields ig-field{max-width:400px}.block-domain ig-multi-fields ig-button{max-width:120px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/block.keywords/block.keywords.component.scss.ngstyle.js.pre-build-optimizer.js